module.exports = __webpack_public_path__ + "static/media/swastik.a1dede29.jpeg";